module.exports = __webpack_public_path__ + "img/package-2.bc97e54f.png";